var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFarcasterBare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7757 27H11V15.3805C11.8385 7.11457 23.4581 6.63516 24.7757 15.3805V27Z",
    fill: "url(#paint0_linear_6927_104176)",
    stroke: "white",
    strokeWidth: 0.958313
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6927_104176",
    x1: 13.0364,
    y1: 12.4739,
    x2: 24.1768,
    y2: 26.4892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.20183,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291135,
    stopColor: "#E3F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776662,
    stopColor: "#007AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarcasterBare);
export default __webpack_public_path__ + "static/media/farcaster-bare.a3baf980ee7968135f88e2866137f584.svg";
export { ForwardRef as ReactComponent };